import MetamaskAuthButton from "@casino/legacy/client/features/Metamask/modules/MetamaskAuthButton";
import useConnectionClicked from "./hooks/useConnectionClicked";
import SocialButton from "./SocialButton";

type Props = {
  handle: Connection;
  mainButton?: boolean;
  otp?: string;
};

const ConnectionButton: FC<Props> = ({ handle, mainButton, otp }) => {
  const handleConnectionClick = useConnectionClicked();

  if (handle === "metamask") {
    return (
      <MetamaskAuthButton
        providerId={handle as Connection}
        mainButton={mainButton}
      />
    );
  }

  return (
    <SocialButton
      key={handle}
      onClick={() => handleConnectionClick({ handle, otp })}
      providerId={handle as Connection}
      mainButton={mainButton}
    />
  );
};

export default ConnectionButton;
